// extracted by mini-css-extract-plugin
module.exports = {"wallex__title":"wallex-title_wallex__title__Q6zWM","md":"wallex-title_md__yUInz","scroll__animation":"wallex-title_scroll__animation__TO5bP","active":"wallex-title_active__SAgxW"};